import { put, call } from "redux-saga/effects";
import log from "loglevel";
import { GetAnalysisTeamsByNameRequestType } from "types";
import * as services from "./service";
import * as types from "./types";
import * as actions from "./action";
import { toastr } from "react-redux-toastr";

export function* getAnalysisSaga(action: types.GetAnalysisActionType) {
  try {
    const getAnalysisResponse = yield call(
      services.getAnalysisService,
      action.payload
    );
    yield put({
      type: actions.GET_ANALYSIS_SUCCESS,
      response: getAnalysisResponse,
    });
  } catch (error) {
    yield put({ type: actions.GET_ANALYSIS_ERROR, response: error });
    toastr.error("Analysis Not Found", `${error.error.message}`);
  }
}

export function* getAnalysesSaga(action: types.GetAnalysesActionType) {
  try {
    const response = yield call(services.getAnalysesService, action.payload);
    yield put({ type: actions.GET_ANALYSES_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ANALYSES_ERROR, response: error });
    toastr.error("Analyses Not Found", `${error.error.message}`);
  }
}

export function* addAnalysisSaga(action: types.AddAnalysisActionType) {
  try {
    toastr.info("Creating Analysis", `This may take a couple of seconds...`);
    const addResponse = yield call(services.addAnalysisService, action.payload);
    const getResponse = yield call(services.getAnalysesService);
    if (addResponse.data) {
      yield put({ type: actions.ADD_ANALYSIS_SUCCESS, response: addResponse });
      yield put({ type: actions.GET_ANALYSES_SUCCESS, response: getResponse });
      toastr.success("Analysis Created", `Added '${action.payload.body.name}'`);
    } else {
      throw addResponse;
    }
  } catch (error) {
    toastr.error("Analysis Not Created", `${error.error.message}`);
    yield put({ type: actions.ADD_ANALYSIS_ERROR, response: error });
  }
}

export function* modifyAnalysisSaga(action: types.ModifyAnalysisActionType) {
  try {
    const modifyResponse = yield call(
      services.modifyAnalysisService,
      action.payload
    );
    const getResponse = yield call(services.getAnalysesService);
    if (modifyResponse.data) {
      yield put({
        type: actions.MODIFY_ANALYSIS_SUCCESS,
        response: modifyResponse,
      });
      yield put({ type: actions.GET_ANALYSES_SUCCESS, response: getResponse });
      toastr.success(
        "Analysis Modified",
        `Modified '${action.payload.body.name}'`
      );
    } else {
      throw modifyResponse;
    }
  } catch (error) {
    yield put({ type: actions.MODIFY_ANALYSIS_ERROR, response: error });
    toastr.error("Analysis Not Modified", `${error.error.message}`);
  }
}

export function* deleteAnalysisSaga(action: types.DeleteAnalysisActionType) {
  try {
    const deleteResponse = yield call(
      services.deleteAnalysisService,
      action.payload
    );
    const getResponse = yield call(services.getAnalysesService);
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_ANALYSIS_SUCCESS,
        response: deleteResponse,
      });
      yield put({ type: actions.GET_ANALYSES_SUCCESS, response: getResponse });
      toastr.success("Analysis Deleted", "All dependencies deleted");
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_ANALYSIS_ERROR, response: error });
    toastr.error("Analysis Not Deleted", `${error.error.message}`);
  }
}

export function* getAnalysisTeamsSaga(
  action: types.GetAnalysisTeamsActionType
) {
  try {
    const response = yield call(
      services.getAnalysisTeamsByNameService,
      action.payload
    );
    yield put({ type: actions.GET_ANALYSIS_TEAMS_SUCCESS, response });
  } catch (error) {
    yield put({ type: actions.GET_ANALYSIS_TEAMS_ERROR, response: error });
  }
}

export function* addAnalysisTeamSaga(action: types.AddAnalysisTeamActionType) {
  try {
    const addResponse = yield call(
      services.addAnalysisTeamService,
      action.payload
    );
    const getAnalysisTeamsRequest: GetAnalysisTeamsByNameRequestType = {
      params: {
        account_name: action.payload.account_name,
        analysis_name: action.payload.analysis_name,
      },
    };
    const getResponse = yield call(
      services.getAnalysisTeamsByNameService,
      getAnalysisTeamsRequest
    );
    if (addResponse.data) {
      yield put({
        type: actions.ADD_ANALYSIS_TEAM_SUCCESS,
        response: addResponse,
      });
      yield put({
        type: actions.GET_ANALYSIS_TEAMS_SUCCESS,
        response: getResponse,
      });
      toastr.success("Team Added to Analysis", "Success");
    } else {
      throw addResponse;
    }
  } catch (error) {
    yield put({ type: actions.ADD_ANALYSIS_TEAM_ERROR, response: error });
    toastr.error("Team Not Added to Analysis", `${error.error.message}`);
  }
}

export function* deleteAnalysisTeamSaga(
  action: types.DeleteAnalysisTeamActionType
) {
  try {
    const deleteResponse = yield call(
      services.deleteAnalysisTeamService,
      action.payload
    );
    const getAnalysisTeamsRequest: GetAnalysisTeamsByNameRequestType = {
      params: {
        account_name: action.payload.account_name,
        analysis_name: action.payload.analysis_name,
      },
    };
    const getResponse = yield call(
      services.getAnalysisTeamsByNameService,
      getAnalysisTeamsRequest
    );
    if (deleteResponse.data) {
      yield put({
        type: actions.DELETE_ANALYSIS_TEAM_SUCCESS,
        response: deleteResponse,
      });
      yield put({
        type: actions.GET_ANALYSIS_TEAMS_SUCCESS,
        response: getResponse,
      });
      toastr.success("Team Removed from Analysis", "Success");
    } else {
      throw deleteResponse;
    }
  } catch (error) {
    yield put({ type: actions.DELETE_ANALYSIS_TEAM_ERROR, response: error });
    toastr.error("Team Not Removed from Analysis", `${error.error.message}`);
  }
}
